/**
 * Development environment — talks directly to the local backend on :3000.
 * Cross-origin requests carry the auth cookie via `withCredentials` (set by the
 * credentials interceptor); the backend enables CORS with credentials.
 */
export const environment = {
  production: false,
  apiBaseUrl: 'https://devcrm-api.normaxcapital.com/v1',
};
